
<head>
  <link href='https://api.mapbox.com/mapbox-gl-js/v1.10.1/mapbox-gl.css' rel='stylesheet' />
  <link href='https://api.tiles.mapbox.com/mapbox-gl-js/v2.9.2/mapbox-gl.css' rel='stylesheet' />
  <link rel="stylesheet" href="https://use.typekit.net/ahw0mno.css"></link>
</head>
<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-HZ9MMXZKNL"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-HZ9MMXZKNL');
</script>

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>


<script>


  export default {
    name: "App",

    metaInfo: {
      titleTemplate: "%s | AntelopeTours",
      htmlAttrs: {
        lang: "en-US",
      },
      meta: [
        { charset: "utf-8" },
        {
          name: "description",
          content: "Listen to the audio tours of Antelope Island State Park",
        },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
      ],
    },
  };
  </script>
  
  <style>
  @import "/src/assets/main.css";
  .v-application--wrap {
    min-height: 0px !important;
  }
  </style>
  